/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Polite_Fair_Guppy_GraceInputs */

const fr_polite_fair_guppy_grace = /** @type {(inputs: Polite_Fair_Guppy_GraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

/**

* @param {Polite_Fair_Guppy_GraceInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const polite_fair_guppy_grace = /** @type {((inputs?: Polite_Fair_Guppy_GraceInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Polite_Fair_Guppy_GraceInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_polite_fair_guppy_grace(inputs)
});